import { useMemo } from 'react';
import { useAppStore } from '../stores';
import { isChildIn } from '../domain';

/**
 * Where the user is a child (docs/plans/children.md): there they see only the chores assigned to
 * them and only mark them done.
 */
export const useHouseholdRoles = () => {
  const households = useAppStore(state => state.chores.households);
  const userId = useAppStore(state => state.auth.user?.uid);

  const childIds = useMemo(
    () => new Set(households.filter(h => isChildIn(h.household, userId)).map(h => h.household.id)),
    [households, userId]
  );

  return {
    isChildIn: (householdId: string) => childIds.has(householdId),
    /** A child in every household they're in: nowhere to add a chore, no one else's to look at. */
    childEverywhere: households.length > 0 && childIds.size === households.length,
  };
};
